import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { RepairReceivablesSheetInterface } from '../interfaces/repair-receivables-sheet.interface';
import { RepairTypeEnum } from '../../repair/enums/repair-type.enum';
import { SubdivisionInterface } from '../../subdivision/interfaces/subdivision.interface';

@Exclude()
export class RepairReceivablesSheetDto
  implements RepairReceivablesSheetInterface
{
  @Expose()
  @ApiProperty({
    title: 'status',
  })
  status!: string;

  @Expose()
  @ApiProperty({
    title: 'repairDescription',
  })
  repairDescription!: string;

  @ApiProperty({
    type: 'string',
    title: 'userId',
  })
  @Expose()
  userId!: string;

  @Expose()
  @ApiProperty({
    title: 'supervisorFirstName',
  })
  supervisorFullNames!: string;

  @Expose()
  @ApiProperty({
    title: 'builderName',
  })
  builderName!: string;

  @Expose()
  @ApiProperty({
    title: 'modelName',
  })
  modelName!: string;

  @Expose()
  @ApiProperty({
    title: 'subdivisionName',
  })
  subdivisionName!: string;

  @Expose()
  @ApiProperty({
    title: 'jobLot',
  })
  jobLot!: string;

  @Expose()
  @ApiProperty({
    title: 'Job Block',
  })
  jobBlock!: string;

  @Expose()
  @ApiProperty({
    title: 'repairType',
  })
  repairType!: RepairTypeEnum;

  @Expose()
  @ApiProperty({
    title: 'readyToBook',
  })
  readyToBook!: boolean;

  @Expose()
  @ApiProperty({
    title: 'internalInvoice',
  })
  internalInvoice!: string;

  @Expose()
  @ApiProperty({
    title: 'hasPhotos',
  })
  hasPhotos!: boolean;

  @Expose()
  @ApiProperty({
    title: 'InternalInvoiceFilled',
  })
  internalInvoiceFilled!: boolean;

  @Expose()
  @ApiProperty({
    title: 'poTotal',
  })
  poTotal!: number;

  @Expose()
  @ApiProperty({
    title: 'poTotalOverride',
  })
  poTotalOverride!: number;

  @Expose()
  @ApiProperty({
    title: 'PO Released',
  })
  poReleased!: boolean;

  @ApiProperty({
    title: 'Repair Days Late Count',
    description: 'Overdue days for a repair or null if "readyToBook".',
    type: 'number',
    nullable: true,
  })
  @Expose()
  repairDaysLateCount!: number | null;

  @Expose()
  @ApiProperty({
    title: 'repairDate',
  })
  repairDate!: Date;

  @Expose()
  @ApiProperty({
    title: 'description',
  })
  description!: string;

  @Expose()
  @ApiProperty({
    title: 'id',
  })
  id!: string;

  @Expose()
  @ApiProperty({
    title: 'createdAt',
  })
  createdAt!: Date;

  @Expose()
  @ApiProperty({
    title: 'updatedAt',
  })
  updatedAt!: Date;

  @Expose()
  @ApiProperty({
    title: 'jobId',
  })
  jobId!: string;

  @Expose()
  @ApiProperty({
    title: 'subdivisionId',
  })
  subdivisionId!: string;

  @Expose()
  @ApiProperty({
    title: 'subdivision',
  })
  subdivision?: SubdivisionInterface | undefined;

  @ApiProperty({
    title: 'hasJobRepairNotes',
  })
  @Expose()
  hasJobRepairNotes!: boolean;

  @ApiProperty({
    title: 'hasContractorAssigned',
  })
  @Expose()
  hasContractorAssigned!: boolean;

  @Expose()
  @ApiProperty({
    title: 'builderId',
  })
  builderId!: string;

  @Expose()
  @ApiProperty({
    title: 'repairId',
  })
  repairId!: string;

  @Expose()
  @ApiProperty({
    title: 'supervisorUserId',
  })
  supervisorUserIds!: string;

  @ApiProperty({
    title: 'isOriginalSupervisorUser',
  })
  @Expose()
  isOriginalSupervisorUser!: boolean;

  @ApiProperty({
    format: 'uuid',
    description:
      'The initial supervisor user id at time of job repair creation.',
  })
  @Expose()
  originalSupervisorUserId!: string;

  @Expose()
  @ApiProperty({
    title: 'originalSupervisorUserFirstName',
  })
  originalSupervisorUserFirstName!: string;

  @Expose()
  @ApiProperty({
    title: 'originalSupervisorUserLastName',
  })
  originalSupervisorUserLastName!: string;

  @ApiProperty({
    title: 'Region Id',
  })
  @Expose()
  regionId!: string;
}
